export default __webpack_public_path__ + "static/media/yukti.5f4b09fb.png";